import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import ChildTabViewModel from "./../../factories/child-tab-view-model";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-number-box";
import "./../../bindings/bao-pager";
import "./../../bindings/bao-upload";
function ServiceLevelAgreementCustomerTabModel(tabPage, parent) {
    var self = this;
    ChildTabViewModel.call(self, tabPage);
    self.Bao = Bao;
    self.ServiceLevelAgreement = parent;
    self.CompleteCheck = function () {
        return true;
    };
    self.RefreshInProgress = ko.observable(false);
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.RefreshGrid();
    });
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        self.RefreshGrid();
    });
    self.CustomerCollection = ko.observableArray([]);
    self.SelectedCustomerRow = ko.observable({});
    self.SelectedCustomerRow.subscribe(function () {
        if (self.SelectedCustomerRow() == null) {
            self.enableDisableButton("EditServiceLevelAgreementCustomer", false);
            self.enableDisableButton("DeleteServiceLevelAgreementCustomer", false);
        }
        else {
            self.enableDisableButton("EditServiceLevelAgreementCustomer", true);
            self.enableDisableButton("DeleteServiceLevelAgreementCustomer", true);
        }
    });
    var _deleteMessage = Bao.Session.GetMessage("msgDeleteServiceLevelAgreementCustomer");
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "AddServiceLevelAgreementCustomer":
                self.ShowServiceLevelAgreementCustomerDialog(self.ServiceLevelAgreement.ServiceLevelAgreementId(), null);
                break;
            case "EditServiceLevelAgreementCustomer":
                if (self.SelectedCustomerRow() != null) {
                    self.EditServiceLevelAgreementCustomer(self.SelectedCustomerRow());
                }
                break;
            case "DeleteServiceLevelAgreementCustomer":
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessage, "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        self.DeleteServiceLevelAgreementCustomer(self.ServiceLevelAgreement.ServiceLevelAgreementId(), self.SelectedCustomerRow().ServiceLevelAgreementCustomerId);
                    }
                });
                break;
        }
    };
    self.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("ServiceLevelAgreementTab/GetServiceLevelAgreementCustomerCollection", JSON.stringify({
            sessionTabId: self.ServiceLevelAgreement.TabPage.SessionTabId,
            serviceLevelAgreementId: self.ServiceLevelAgreement.ServiceLevelAgreementId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedCustomerRow(null);
            self.TotalRows(0);
            self.CustomerCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.CustomerCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
        });
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    self.AddServiceLevelAgreementCustomer = function (model, serviceLevelAgreementId) {
        tabPage.IsLoading(true);
        Bao.post("ServiceLevelAgreementTab/AddServiceLevelAgreementCustomer", JSON.stringify({
            sessionTabId: self.ServiceLevelAgreement.TabPage.SessionTabId,
            customerModel: ko.map.toJS(model),
            serviceLevelAgreementId: serviceLevelAgreementId
        }), function () {
            self.ServiceLevelAgreement.TabPage.DirtyFlag(true);
            self.RefreshGrid();
        });
    };
    self.DeleteServiceLevelAgreementCustomer = function (serviceLevelAgreementId, serviceLevelAgreementCustomerId) {
        self.RefreshInProgress(true);
        Bao.post("ServiceLevelAgreementTab/DeleteServiceLevelAgreementCustomer", JSON.stringify({
            sessionTabId: self.ServiceLevelAgreement.TabPage.SessionTabId,
            serviceLevelAgreementId: serviceLevelAgreementId,
            serviceLevelAgreementCustomerId: serviceLevelAgreementCustomerId
        }), function () {
            self.RefreshInProgress(false);
            self.ServiceLevelAgreement.TabPage.DirtyFlag(true);
            self.RefreshGrid();
        });
    };
    self.EditServiceLevelAgreementCustomer = function (item) {
        self.ShowServiceLevelAgreementCustomerDialog(self.ServiceLevelAgreement.ServiceLevelAgreementId(), item.ServiceLevelAgreementCustomerId);
    };
    self.ShowServiceLevelAgreementCustomerDialog = function (serviceLevelAgreementId, serviceLevelAgreementCustomerId) {
        window.baorequire(["ViewModels/Dialogs/ServiceLevelAgreementCustomerDialog"], function (vm) {
            var dialog = new vm(tabPage, self);
            dialog.Show(serviceLevelAgreementId, serviceLevelAgreementCustomerId);
            dialog.DialogResult.subscribe(function (dialogResult) {
                if (dialogResult == "ok") {
                    self.AddServiceLevelAgreementCustomer(dialog.DialogViewModel, self.ServiceLevelAgreement.ServiceLevelAgreementId());
                }
            });
        });
    };
    self.enableDisableButton = function (actionKey, enabled) { };
    self.Refresh = function () {
        var def = $.Deferred();
        Bao.post("ServiceLevelAgreementTab/ResetServiceLevelAgreementCustomer", JSON.stringify({
            sessionTabId: self.ServiceLevelAgreement.TabPage.SessionTabId
        }), function () {
            self.RefreshGrid().then(function () {
                def.resolve();
            });
        });
        return def.promise();
    };
    self.Save = function () {
        return Bao.post("ServiceLevelAgreementTab/SaveServiceLevelAgreementCustomer", JSON.stringify({
            sessionTabId: self.ServiceLevelAgreement.TabPage.SessionTabId,
            serviceLevelAgreementId: self.ServiceLevelAgreement.ServiceLevelAgreementId(),
            saveTime: parent.SaveTime()
        }));
    };
    self.loaded = function () {
        return self.Refresh();
    };
}
;
Bao.inherit(ServiceLevelAgreementCustomerTabModel, ChildTabViewModel);
export default ServiceLevelAgreementCustomerTabModel;